import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import useBrandTranslation from "../hooks/useBrandTranslation";

export default function Logout() {
  const { t } = useBrandTranslation();
  sessionStorage.clear();
  localStorage.clear();
  window.location.assign("/login");

  return <div></div>;
}
